import { getRelativeValue } from 'src/components/dashboard/DashboardPage/helper';
import type { StackedBarChartProps } from 'src/components/followUp/common/BaseWidgets/StackedBarChart';
import calculateBarChartValues from 'src/components/followUp/common/ChartBackground/calculateBarChartValues';
import type { AggregateList } from 'src/components/followUp/common/types';

const mapResultsToBarChartData = (
  data?: AggregateList,
  comparisonData?: { label: string; value: number }[],
  labels?: { promoter: string; passive: string; detractor: string },
) =>
  data?.results.map((bar) => ({
    label: bar.label,
    stacks: [
      {
        value: bar.value,
        stackLabel:
          Number(bar.label) > 8
            ? labels?.promoter ?? 'Promoter'
            : Number(bar.label) > 6
              ? labels?.passive ?? 'Passive'
              : labels?.detractor ?? 'Detractor',
      },
    ],
    comparisonValue: comparisonData?.find(
      (comparisonBar) => comparisonBar.label === bar.label,
    )?.value,
  })) ?? [];

export const mapAggregateListToBarChartData = (
  data?: AggregateList,
  comparisonData?: AggregateList,
  labels?: { promoter: string; passive: string; detractor: string },
): StackedBarChartProps['bars'] => {
  const comparisonChartData = mapResultsToBarChartData(
    comparisonData,
    undefined,
    labels,
  );
  const { totalValue: comparisonTotals } = calculateBarChartValues({
    bars: comparisonChartData,
  });
  const comparisonDataPercentages = comparisonChartData.map((bar) => ({
    label: bar.label,
    value: getRelativeValue(bar.stacks[0].value, comparisonTotals, 0),
  }));

  return mapResultsToBarChartData(data, comparisonDataPercentages, labels);
};
